import * as winston from 'winston';
import BrowserConsole from 'winston-transport-browserconsole';
import moment from 'moment';
import { SPLAT } from 'triple-beam';
import { RetailElectronAPI } from '../electron/RetailElectronAPI';
import { LoggingLevels, LogLevels } from './log-levels';

const isElectron = !!RetailElectronAPI;
const pid = isElectron ? require('process').pid || 0 : undefined;

// logging level for web runtime
const logLevel = isElectron
  ? LogLevels.ERROR_LEVEL // logs logged in electron-logger.ts so only error logs to the console
  : LogLevels.DEBUG_LEVEL; // when running in browser mode all output is wanted being it is not an electron prod deploy

const consoleLoggingFormat = winston.format.printf(info => {
  return JSON.stringify(info[SPLAT], undefined, 0);
});

// this instance of winston will only be used on the web side
const transports: winston.transport[] = [
  new BrowserConsole({
    format: consoleLoggingFormat,
    level: logLevel,
  }),
];

const winstonLogger = winston.createLogger({
  levels: LoggingLevels,
  transports,
});

// JSON containing fields from the legacy log entry
const createJSON = (input: LoggingInput, timestamp: string, level: string, pid?: string): any => {
  return {
    timestamp,
    ...(pid && { pid }),
    severity: level,
    ...(input.source && { source: input.source }),
    ...(input.data && { data: input.data }),
    log: input.message,
  };
};

// Date formatter following the legacy format: 2000-01-01 12:30:50,999
const now = (): string => {
  const date = moment();

  const formatedDate = date.format('YYYY-MM-DD hh:mm:ss');
  const milliseconds = date.millisecond();

  return `${formatedDate},${milliseconds}`;
};

const log = (input: LoggingInput, level: string, pid?: string): void => {
  const timestamp = now();
  const json = createJSON(input, timestamp, level, pid);
  winstonLogger.log(level, input.message, json);
  if (isElectron) {
    // send log to main electron process
    RetailElectronAPI.log(level, input.message, json);
  }
};

export interface LoggingInput {
  message: string;
  source?: string;
  data?: object;
}

const XLRLogger = {
  error: (input: LoggingInput): void => {
    log(input, LogLevels.ERROR_LEVEL, pid);
  },
  info: (input: LoggingInput): void => {
    log(input, LogLevels.INFO_LEVEL, pid);
  },
  debug: (input: LoggingInput): void => {
    log(input, LogLevels.DEBUG_LEVEL, pid);
  },
};

export default XLRLogger;
